const dizionario_generico = {
  territorio:{
    it: `Territorio`,
    en: `Territory`,
    de: `Gebiet`
  },
  zona: {
    it: `Zona`,
    en: `Area`,
    de: `Zone`
  },
  località: {
    it: `Località`,
    en: `Location`,
    de: `Ort`
  },
  categoria: {
    it: `Categoria *`,
    en: `Category *`,
    de: `Kategorie *`
  },
  tutte: {
    it: `Tutte`,
    en: `All`,
    de: `Alles`
  },
  camping: {
    it: 'Camping',
    en: `Camping`,
    de: `Camping`
  },
  campeggio: {
    it: 'Camping',
    en: `Camping`,
    de: `Camping`
  },
  hotel: {
    it: `Hotel`,
    en: `Hotel`,
    de: `Hotel`
  },
  mostra_tutte: {
    it: `Mostra tutte`,
    en: `Show all`,
    de: `Alles zeigen`
  },
  chiedi_conferma_chiusura: {
    it: `Sei sicuro di voler chiudere la pagina senza salvare?`,
    en: `Are you sure you want to close the page without saving?`,
    de: `Möchten Sie die Seite wirklich ohne Speichern schließen?`
  },
  per: {
    it: `Per`,
    en: `By`,
    de: `von`
  },
  scorporo: {
    it: `Scorporo`,
    en: `Extra Values`,
    de: `Die Werte der Extras`
  },
  dettagliato_per: {
    it: `Dettagliato Per`,
    en: `Detailed By`,
    de: `Ausführlich nach`
  },
  totale: {
    it: `Totale`,
    en: `Total`,
    de: `Gesamt`
  },
  trattamento: {
    it: `Trattamento`,
    en: `Arrangement`,
    de: `Vereinbarung`
  },
  canale: {
    it: `Canale`,
    en: `Sales Channel`,
    de: `Vertriebskanal`
  },
  mercato: {
    it: `Mercato`,
    en: `Market Segment`,
    de: `Markt`
  },
  nazionalità: {
    it: `Nazionalità`,
    en: `Nationality`,
    de: `Nationalität`
  },
  prodotto: {
    it: `Prodotto`,
    en: `Product`,
    de: `Produkt`
  },
  utenza: {
    it: `Utenza`,
    en: `User`,
    de: `Benutzer`
  },
  stato: {
    it: `Stato Prenotazione`,
    en: `Reservation Status`,
    de: `Reservierungsstatus`
  },
  standard: {
    it: `Standard`,
    en: `Standard`,
    de: `Standard`
  },
  superior: {
    it: `Superior`,
    en: `Superior`,
    de: `Superior`
  },
  deluxe: {
    it: `Deluxe`,
    en: `Deluxe`,
    de: `Deluxe`
  },
  suite: {
    it: `Suite`,
    en: `Suite`,
    de: `Suite`
  },
  piazzola: {
    it: `Piazzole`,
    en: `Pitch`,
    de: `Stellplatz`
  },
  bungalow: {
    it: `Bungalow / Villette `,
    en: `Bungalow`,
    de: `Bungalow`
  },
  caravan: {
    it: `Mobile Home`,
    en: `Mobile Homes`,
    de: `Mobilheim`
  },
  tenda: {
    it: `Tende / Glamping`,
    en: `Tent`,
    de: `Zelt`
  },
  persona: {
    it: `Persona`,
    en: `Person`,
    de: `Person`
  },
  elettricità: {
    it: `Elettricità`,
    en: `Electricity`,
    de: `Strom`
  },
  gas: {
    it: `Gas`,
    en: `Gas`,
    de: `Gas`
  },
  acqua: {
    it: `Acqua`,
    en: `Water`,
    de: `Wasser`
  },
  composizione_percentualizzata: {
    it: `Composizione Percentualizzata`,
    en: `% Mix`,
    de: `Prozentuale Zusammensetzung`
  },
  composizione_pura: {
    it: `Composizione`,
    en: `Composition`,
    de: `Zusammensetzung`
  },
  solo_camera: {
    it: `Solo Camera`,
    en: `Room Only`,
    de: `Nur Zimmer`
  },
  colazione: {
    it: `Bed & Breakfast`,
    en: `Bed & Breakfast`,
    de: `Zimmer mit Frühstück`
  },
  mezza_pensione: {
    it: `Mezza Pensione`,
    en: `Half Board`,
    de: `Halbpension`
  },
  pensione_completa: {
    it: `Pensione Completa`,
    en: `Full Board`,
    de: `Vollpension`
  },
  tutto_incluso: {
    it: `All Inclusive`,
    en: `All Inclusive`,
    de: `All Inclusive`
  },
  diretto_offline: {
    it: `Diretto - Offline`,
    en: `Direct - Offline`,
    de: `Direkt - Offline`
  },
  diretto_web: {
    it: `Diretto - Sito Web`,
    en: `Direct - Website`,
    de: `Direkt - Website`
  },
  distribuzione: {
    it: `Global Distribution System`,
    en: `Global Distribution System`,
    de: `Globales Vertriebssystem`
  },
  agenzie_booking: {
    it: `Agenzie - Booking`,
    en: `Agency - Booking.com`,
    de: `Agentur - Booking.com`
  },
  agenzie_expedia: {
    it: `Agenzie - Expedia`,
    en: `Agency - Expedia`,
    de: `Agentur - Expedia`
  },
  altre_agenzie_online: {
    it: `Agenzie - altre OTA`,
    en: `Agency - other OTA`,
    de: `Agentur - andere OTA`
  },
  totale_agenzie_online: {
    it: `Totale Agenzie OTA`,
    en: `Total OTA`,
    de: `Total OTA`
  },
  switzerland_travel_center: {
    it: `Agenzie - Switzerland Travel Center`,
    en: `Agency - Switzerland Travel Center`,
    de: `Agentur - Switzerland Travel Center`,
  },
  portale_destinazione: {
    it: `Agenzie - Portale Destinazione`,
    en: `Agency - Destination Portal`,
    de: `Agentur - Destinations-Website`
  },
  altri: {
    it: `Altri`,
    en: `Other`,
    de: `Andere`
  },
  altri_canali: {
    da_ritradurre: ``,
    it: `Altri / Tour Operator`,
    en: `Other / Tour Operator`,
    de: `Andere / Reiseveranstalter`
  },
  retail: {
    it: `Retail`,
    en: `Individual Retail`,
    de: `Einzelhandel`
  },
  business: {
    it: `Negoziati`,
    en: `Individual Business`,
    de: `Business`
  },
  gruppi_leisure: {
    it: `Gruppi Leisure`,
    en: `Leisure Group`,
    de: `Freizeitgruppen`
  },
  gruppi_business: {
    it: `Gruppi Business`,
    en: `Business Group`,
    de: `Geschäftsreisende`
  },
  negoziati: {
    it: `Negoziati (forfait, stagionali e vuoto per pieno)`,
    en: `Negotiated (flat rate, seasonal and allotment)`,
    de: `Verhandelt (Pauschale, saisonal und Kontingent)`
  },
  extra: {
    it: `Extra`,
    en: `Extra`,
    de: `Extra`
  },
  da_escludere: {
    it: `Da Escludere`,
    en: `To Exclude`,
    de: `Ausgenommen`
  },
  check_in: {
    it: `Check-In`,
    en: `Check-In`,
    de: `Check-In`
  },
  check_out: {
    it: `Check-Out`,
    en: `Check-Out`,
    de: `Check-Out`
  },
  opzione: {
    it: `Opzione`,
    en: `Option`,
    de: `Option`
  },
  opzione_con_detrazione: {
    it: `Opzione con Detrazione`,
    en: `Option with detraction`,
    de: `Abzugsmöglichkeit`
  },
  lista_attesa: {
    it: `Lista d'Attesa`,
    en: `Waiting list`,
    de: `Warteliste`
  },
  inserito: {
    it: `Inserito`,
    en: `Inserted`,
    de: `Bestätigt`
  },
  ignorato: {
    it: `Ignorata`,
    en: `Ignored`,
    de: `Ignoriert`
  },
  no_show: {
    it: `No Show`,
    en: `No Show`,
    de: `No Show`
  },
  cancellato: {
    it: `Cancellata`,
    en: `Cancelled`,
    de: `Gelöscht`
  },
  migliori_7: {
    it: `Top 7`,
    en: `Top 7`,
    de: `Top 7`
  },
  migliori_7_percentualizzate: {
    it: `Top 7 Percentualizzato`,
    en: `Top 7 Percentualized`,
    de: `Top 7 Prozent`
  },
  dimensioni: {
    it: `Dimensioni`,
    en: `Dimensions`,
    de: `Maße`
  },
  posizione: {
    it: `Posizione`,
    en: `Position`,
    de: `Position`
  },
  servizi: {
    it: `Servizi`,
    en: `Services`,
    de: `Dienstleistungen`
  },
  locali: {
    it: `Locali`,
    en: `Areas`,
    de: `Zimmer`
  },
  fascia_prezzo: {
    it: 'Fascia prezzo',
    en: 'Price range',
    de: 'Preisspanne'
  },
  fascia_1: {
    it: `Fascia 1`,
    en: `Category 1`,
    de: `Kategorie 1`
  },
  fascia_2: {
    it: `Fascia 2`,
    en: `Category 2`,
    de: `Kategorie 2`
  },
  fascia_3: {
    it: `Fascia 3`,
    en: `Category 3`,
    de: `Kategorie 3`
  },
  fino_a_70mq: {
    it: `Fino a 70mq`,
    en: `Up to 70sqm`,
    de: `Bis zu 70qm²`
  },
  fino_a_110mq: {
    it: `Fino a 110mq`,
    en: `Up to 110sqm`,
    de: `Bis zu 110qm²`
  },
  oltre_110mq: {
    it: `Oltre 110mq`,
    en: `Over 110sqm`,
    de: `Über 110qm`
  },
  privilegiata: {
    it: `Privilegiata`,
    en: `Privileged`,
    de: `Privilegiert`
  },
  non_privilegiata: {
    it: `Non Privilegiata`,
    en: `Not Privileged`,
    de: `Nicht privilegiert`
  },
  con_bagno: {
    it: `Con Bagno`,
    en: `With bathroom`,
    de: `Mit Badezimmer`
  },
  senza_bagno: {
    it: `Senza Bagno`,
    en: `Without bathroom`,
    de: `Ohne Badezimmer`
  },
  bilocale: {
    it: `2 o meno Locali`,
    en: `Two or less Areas`,
    de: `2 oder weniger Zimmer`
  },
  trilocale: {
    it: `3 Locali`,
    en: `Three Areas`,
    de: `3 Zimmer`
  },
  più_di_3_locali: {
    it: `Più di 3 Locali`,
    en: `More than Three Areas`,
    de: `Mehr als 3 Zimmer`
  },
  non_specificato: {
    it: `Non Specificato`,
    en: `Not Specified`,
    de: `Keine Angabe`
  },
  sospeso: {
    it: `Sospeso`,
    en: `Suspended`,
    de: `Ausgesetzt`
  },
  attributi: {
    it: `Attributi`,
    en: `Attributes`,
    de: `Eigenschaften`
  },
  non_filtrare: {
    it: `Non filtrare per`,
    en: `Don't filter by`,
    de: `Nicht filtern nach`
  },
  si: {
    it: `Si`,
    en: `Yes`,
    de: `Ja`
  },
  no: {
    it: `No`,
    en: `No`,
    de: `Nein`
  },
  clicca_qui: {
    it: `clicca qui`,
    en: `click here`,
    de: `Hier klicken`
  },
  tutti: {
    it: `Tutti`,
    en: `All`,
    de: `Alles`
  },
  salva: {
    it: `Salva`,
    en: `Save`,
    de: `Speichern`
  },
  salvataggio_in_corso: {
    it: `Salvataggio..`,
    en: `Saving..`,
    de: `Speichert..`
  },
  invia: {
    it: `Invia`,
    en: `Send`,
    de: `Senden`
  },
  conferma: {
    it: `Conferma`,
    en: `Confirm`,
    de: `Bestätigen`
  },
  annulla: {
    it: `Annulla`,
    en: `Discard`,
    de: `Verwerfen`
  },
  mostra: {
    it: `Mostra`,
    en: `Show`,
    de: `Zeigen`
  },
  nascondi: {
    it: `Nascondi`,
    en: `Hide`,
    de: `Verstecken`
  },
  crea: {
    it: `Crea`,
    en: `Create`,
    de: `Erstellen`
  },
  aggiungi: {
    it: `Aggiungi`,
    en: `Add`,
    de: `Hinzufügen`
  },
  visualizza: {
    it: `Visualizza`,
    en: `View`,
    de: `Ansehen`
  },
  rinomina: {
    it: `Rinomina`,
    en: `Rename`,
    de: `Umbenennen`
  },
  affermativo: {
    it: `Si`,
    en: `Yes`,
    de: `Ja`
  },
  negativo: {
    it: `No`,
    en: `No`,
    de: `Nein`
  },
  completato: {
    it: `Operazione completata con successo`,
    en: `Operation completed successfully`,
    de: `Operation erfolgreich abgeschlossen`
  },
  errore: {
    it: `Si è verificato un errore`,
    en: `An error occurred`,
    de: `Es ist ein Fehler aufgetreten`
  },
  nessuna_connessione: {
    it: `Nessuna connessione. <br>Verificare di essere connessi a Internet e riprovare`,
    en: `No connection. <br>Check your Internet connection and retry`,
    de: `Keine Verbindung. <br>Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut`
  },
  totale: {
    it: `Totale`,
    en: `Total`,
    de: `Gesamt`
  },
  nessun_dato_trovato: {
    it: `Nessun dato trovato`,
    en: `No data found`,
    de: `Keine Daten gefunden`
  },
  continua: {
    it: `Continua`,
    en: `Continue`,
    de: `Fortsetzen`
  },
  torna_indietro: {
    it: `Torna indietro`,
    en: `Go back`,
    de: `Zurückgehen`
  },
  riprova: {
    it: `Riprova`,
    en: `Retry`,
    de: `Erneut versuchen`
  },
  esporta: {
    it: `Esporta`,
    en: `Export`,
    de: `Exportieren`
  },
  modifica: {
    it: `Modifica`,
    en: `Edit`,
    de: `Bearbeiten`
  },
  cancella: {
    it: `Cancella`,
    en: `Delete`,
    de: `Löschen`
  },
  approfondisci: {
    it: `Approfondisci`,
    en: `See More`,
    de: `Mehr erfahren`
  },
  scarica: {
    it: `Scarica`,
    en: `Download`,
    de: `Herunterladen`
  },
  in_coda: {
    it: `In coda`,
    en: `Queued`,
    de: `In der Warteschlange`
  },
  in_lettura: {
    it: `In lettura`,
    en: `Reading`,
    de: `Wird gelesen`
  },
  letta: {
    it: `Letta`,
    en: `Read`,
    de: `Gelesen`
  },
  in_errore: {
    it: `In errore`,
    en: `Error`,
    de: `Fehler`
  },
  bloccata: {
    it: `Bloccata`,
    en: `Blocked`,
    de: `Gesperrt`
  },
  vuota: {
    it: `Vuota`,
    en: `Empty`,
    de: `Leer`
  },
  da_rispondere: {
    it: `Da rispondere`,
    en: `To answer`,
    de: `Zu beantworten`
  },
  da_reingerire: {
    it: `Da reingerire`,
    en: `To re-enter`,
    de: `Wieder einzugeben`
  },
  industry: {
    it: `Categoria merceologica`,
    en: `Industry`,
    de: `Branche`
  },
  nationality: {
    it: `Nazionalità`,
    en: `Nationality`,
    de: `Nationalität`
  },
  product: {
    it: `Prodotto`,
    en: `Product`,
    de: `Produkt`
  },
  customer: {
    it: `Cliente`,
    en: `Customer`,
    de: `Kunde`
  },
  "airlines and duty free shops": {
    "it": "Compagnie aeree e negozi duty free",
    "en": "Airlines and Duty Free Shops",
    "de": "Fluggesellschaften und Duty-Free-Shops"
  },
  "apparel": {
    "it": "Abbigliamento",
    "en": "Apparel",
    "de": "Bekleidung"
  },
  "automotive fuel": {
    "it": "Carburante",
    "en": "Automotive Fuel",
    "de": "Kraftstoff"
  },
  "bars, wine and liquor stores": {
    "it": "Bar, negozi di vino e liquori",
    "en": "Bars, Wine and Liquor Stores",
    "de": "Bars, Wein- und Spirituosengeschäfte"
  },
  "bus, train and highway transportation": {
    "it": "Trasporto via bus, treno e autostrada",
    "en": "Bus, Train and Highway Transportation",
    "de": "Bus-, Bahn- und Autobahntransport"
  },
  "cosmetics and beauty services": {
    "it": "Servizi di bellezza",
    "en": "Cosmetics and Beauty Services",
    "de": "Kosmetik- und Schönheitsdienstleistungen"
  },
  "eating places": {
    "it": "Ristorazione",
    "en": "Eating Places",
    "de": "Gaststätten"
  },
  "entertainment": {
    "it": "Intrattenimento",
    "en": "Entertainment",
    "de": "Unterhaltung"
  },
  "ferries and boats": {
    "it": "Trasporto via traghetti e imbarcazioni",
    "en": "Ferries and Boats",
    "de": "Fähren und Boote"
  },
  "grocery stores and specialty food stores": {
    "it": "Supermercati e altri negozi di alimentari",
    "en": "Grocery Stores and Specialty Food Stores",
    "de": "Lebensmittelgeschäfte und Feinkostläden"
  },
  "hotels": {
    "it": "Hotel",
    "en": "Hotels",
    "de": "Hotels"
  },
  "houseware": {
    "it": "Articoli e oggettistica per la casa",
    "en": "Houseware",
    "de": "Haushaltswaren"
  },
  "insurance and financial services": {
    "it": "Assicurazioni e servizi finanziari",
    "en": "Insurance and Financial Services",
    "de": "Versicherungs- und Finanzdienstleistungen"
  },
  "jewelry": {
    "it": "Negozi di gioielleria",
    "en": "Jewelry",
    "de": "Schmuck"
  },
  "shopping": {
    "it": "Shopping",
    "en": "Shopping",
    "de": "Einkaufen"
  },
  "taxi": {
    "it": "Taxi",
    "en": "Taxi",
    "de": "Taxi"
  },
  "travel agencies and tour operators": {
    "it": "Agenzie di viaggio e tour operator",
    "en": "Travel Agencies and Tour Operators",
    "de": "Reisebüros und Reiseveranstalter"
  },
  "utilities": {
    "it": "Utilities",
    "en": "Utilities",
    "de": "Versorgungsunternehmen"
  },
  "vehicle rental": {
    "it": "Noleggio autoveicoli",
    "en": "Vehicle Rental",
    "de": "Fahrzeugvermietung"
  },
  "other": {
    "it": "Altri prodotti e servizi",
    "en": "Other",
    "de": "Andere Produkte und Dienstleistungen"
  },
  interaziendale: {
    it: `Business`,
    en: `Business`,
    de: `Geschäftlich`
  },
  consumatore: {
    it: `Consumatore`,
    en: `Consumer`,
    de: `Verbraucher`
  },
  domestic: {
    it: `Nazionale`,
    en: `Domestic`,
    de: `Inland`
  },
  crossborder: {
    it: `Transfrontaliero`,
    en: `Crossborder`,
    de: `Grenzüberschreitend`
  },
  errori: {
    spiacenti: {
      it: `Spiacenti, si è verificato un errore nella richiesta`,
      en: `We're sorry, there was an error in the request`,
      de: `Entschuldigung, es ist ein Fehler in der Anfrage aufgetreten`
    },
    contatta_supporto: {
      it: `Ti invitiamo a riprovare più tardi, o a contattare il supporto all'indirizzo <a href="mailto: supporto@hbenchmark.com">supporto@hbenchmark.com</a>`,
      en: `Please try again later, or contact support at <a href="mailto: supporto@hbenchmark.com">supporto@hbenchmark.com</a>`,
      de: `Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support unter <a href="mailto: supporto@hbenchmark.com">supporto@hbenchmark.com</a>`
    }
  },
  validazioni: {
    richiesto: {
      it: `Questo campo è obbligatorio`,
      en: `This field is mandatory`,
      de: `Das Feld ist verpflichtend`
    },
    email: {
      it: `Email non valida`,
      en: `Invalid email`,
      de: `Ungültige E-Mail-Adresse`
    },
    gettone: {
      it: `Il gettone può essere composto solo da quattro lettere`,
      en: `The token can only have four letters`,
      de: `Der Token darf nur aus vier Buchstaben bestehen`
    },
    validazione_password: {
      it: `La password deve avere almeno 8 caratteri, di cui almeno uno maiuscolo, almeno uno minuscolo, e almeno un numero`,
      en: `The password must have at least 8 characters, of which at least one is uppercase, at least one lowercase, and at least one number`,
      de: `Das Passwort muss aus mindestens 8 Zeichen bestehen, davon mindestens ein Großbuchstabe, mindestens ein Kleinbuchstabe und mindestens eine Zahl`
    },
    conferma_non_corrisponde: {
      it: `Questo campo non coincide con la conferma`,
      en: `This field does not match confirmation`,
      de: `Dieses Feld stimmt nicht mit der Bestätigung überein`
    },
    utente_esiste_già: {
      it: `Questo utente esiste già`,
      en: `This user already exists`,
      de: `Dieser Benutzer existiert bereits`
    }
  }
}

export { dizionario_generico }